import { Resource } from 'ngx-jsonapi';

/**
 * Framework-agnostic `Currency` resource for the `systems` capability.
 * Mirrors the `attributes` of the legacy `@app/core/resources/currency.ts`,
 * without its `relationships.best_rates` (see design.md Decision 2 of
 * `systems-capability`: no consumer of this capability reads `best_rates`).
 */
export class Currency extends Resource {
    public type: string = 'currencies';
    public attributes: {
        default_minimum: number;
        title: string;
        rank: number;
        price: number;
    } = {
        default_minimum: 0,
        title: '',
        rank: 0,
        price: 0,
    };
}
